import cloudflareImageUrl from '@/utilities/cloudflareImageUrl'

/** @type (src: string) => string */
const normalizeSrc = (src) => {
    return src.startsWith('/') ? src.slice(1) : src
}

// Docs: https://developers.cloudflare.com/images/transform-images
/** @type {import('next/image').ImageLoader} */
export default function cloudflareLoader({ src, width, quality }) {
    return cloudflareImageUrl({ src, width, quality })
}
